import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const Search = Input.Search;

function Project() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();

  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      key: "name",
    },

    {
      title: "Action",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              className="tb-view"
              onClick={() => {
                setVisible(true);
                setSelected(record);
              }}
            >
              <i className="fa fa-light fa-pencil"></i> Edit
            </Button>
            <Button
              className="tb-view"
              danger
              onClick={() => handleDelete(record)}
            >
              <i className="fa fa-light"></i> Delete
            </Button>
          </div>
        );
      },
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  const { confirm } = Modal;

  const handleDelete = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to delete this project? </Button>,
        onOk() {
          deleteProject(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const deleteProject = (record) => {
    setLoading(true);
    request({
      url: `/admin/project/delete-project/${record._id}`,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast("Project deleted successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message || "Failed to delete project", Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (pagination, filters) => {
    request({
      url: `/admin/project/list?page=${pagination.current}&limit=${pagination.pageSize}&search=${debouncedSearchText}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.docs);
        setPagination({
          current: pagination.current,
          total: data.data.totalDocs,
        });
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Project Management"
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                  <Button onClick={() => setVisible(true)}>Add Project</Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
  }, [data]);

  const onCreate = (values) => {
    setLoading(true);

    request({
      url: data
        ? `/admin/project/edit-project/${data._id}`
        : `/admin/project/add-project`,
      method: data ? "PUT" : "POST",
      data: values,
      onSuccess: () => {
        setLoading(false);
        refresh();
        hide();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Edit" : "Create"} project`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Form.Item
          label="Project Name"
          name="name"
          rules={[
            { required: true, message: "Please enter the project name!" },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Project;
